import {createContext} from 'react';

export enum TemplateInfoEnum {
  ORIGINAL_ID = 'originalId',
  MODEL_ORIGINAL_ID = 'modelOriginalId',
  MODEL_NAME = 'modelName',
  SLUG = 'slug'
}

export type TemplateInfoContextType = {
  [key in TemplateInfoEnum]: string;
};

export const TemplateInfoContext = createContext<TemplateInfoContextType>({
  [TemplateInfoEnum.SLUG]: undefined,
  [TemplateInfoEnum.MODEL_NAME]: undefined,
  [TemplateInfoEnum.MODEL_ORIGINAL_ID]: undefined,
  [TemplateInfoEnum.ORIGINAL_ID]: undefined
});
